import React, { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import FormHeader from './layout/FormHeader';
import Stepper from './layout/Stepper';
import FormNavigation from './layout/FormNavigation';
import Step1Endereco from './steps/Step1Endereco/Step1Endereco';
import Step2Pagamento from './steps/Step2Pagamento/Step2Pagamento';
import Step3Confirmacao from './steps/Step3Confirmacao/Step3Confirmacao';
import { useFormulario } from '../hooks/useFormulario';
import { useFileUpload } from '../hooks/useFileUpload';
import { useFormStore } from '../store/formStore';
import type { CategoriaArquivo } from '@engenharia/shared';

const TOTAL_STEPS = 3;

interface WizardFormProps {
  existingId?: number;
}

export default function WizardForm({ existingId }: WizardFormProps) {
  const { form, formularioId, currentStep, setCurrentStep, submitting, salvar, enviar } = useFormulario(existingId);
  const { upload, deletar, states: uploadStates } = useFileUpload(formularioId);
  const loadCatalogos = useFormStore((s) => s.loadCatalogos);

  useEffect(() => {
    loadCatalogos();
  }, [loadCatalogos]);

  useEffect(() => {
    form.setValue('data_contrato', new Date().toISOString().split('T')[0]);
  }, []);

  const handleUpload = async (categoria: CategoriaArquivo, file: File) => {
    const id = await upload(categoria, file);
    if (id) {
      useFormStore.getState().addArquivo({
        id,
        formulario_id: formularioId!,
        categoria,
        storage_key: '',
        bucket: 'engenharia-solar',
        nome_original: file.name,
        mime_type: file.type,
        tamanho_bytes: file.size,
      });
    }
  };

  const handleDelete = async (id: number) => {
    const ok = await deletar(id);
    if (ok) useFormStore.getState().removeArquivo(id);
  };

  const handleNext = () => setCurrentStep(Math.min(currentStep + 1, TOTAL_STEPS - 1));
  const handlePrev = () => setCurrentStep(Math.max(currentStep - 1, 0));
  const handleSave = () => form.handleSubmit(salvar)();
  const handleSubmit = () => form.handleSubmit(enviar)();

  return (
    <FormProvider {...form}>
      <div className="max-w-5xl mx-auto p-4">
        <FormHeader />
        <Stepper current={currentStep} onChange={setCurrentStep} />

        <div className={currentStep !== 0 ? 'step-hidden' : ''}>
          <Step1Endereco onUpload={handleUpload} onDelete={handleDelete} uploadStates={uploadStates} />
        </div>
        <div className={currentStep !== 1 ? 'step-hidden' : ''}>
          <Step2Pagamento onUpload={handleUpload} onDelete={handleDelete} uploadStates={uploadStates} />
        </div>
        <div className={currentStep !== 2 ? 'step-hidden' : ''}>
          <Step3Confirmacao />
        </div>

        <FormNavigation
          currentStep={currentStep}
          totalSteps={TOTAL_STEPS}
          onPrev={handlePrev}
          onNext={handleNext}
          onSave={handleSave}
          onSubmit={handleSubmit}
          submitting={submitting}
        />
      </div>
    </FormProvider>
  );
}
